//Third party libraries
import { Link, useLocation } from 'react-router';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
//Assets and Miscellaneous
import type { DashboardType } from '../../../types/Analytics';
import { getTdmCompleteOverCount } from '../../../utils/analytics';
//Custom components
import StatCard from '../../Sherpa/Projects/Project/StatCard/StatCard';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export default function DeliverableWidget({ dashboard }: { dashboard: DashboardType }) {
  const location = useLocation();

  const fetchDeliverablesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.DELIVERABLES_COUNT,
  });
  const deliverablesWidgetData = fetchDeliverablesWidgetData?.data?.data;

  const deliverablesStat = getTdmCompleteOverCount(deliverablesWidgetData);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.DELIVERABLES_COUNT}>
      <Link to={`${location.pathname}/deliverables`}>
        <StatCard
          label='Deliverables'
          stats={{
            completed: deliverablesStat.completeCount,
            total: deliverablesStat.totalCount,
          }}
        />
      </Link>
    </WidgetLayout>
  );
}
